import ApiClient from '~/ApiClient';

import Country from './Country';

export interface Result {
	items: Country[];
}

export default function findCountries(client: ApiClient): Promise<Result> {
	return client
		.fetch('countries')
		.then((response) => response.json())
		.then((response) => ({
			items: response.items.map(
				(country: { alpha2: string; name: string }) => new Country(country.alpha2, country.name)
			),
		}));
}
